<template>
  <v-row>
    <v-col>
      <v-select
        v-if="DRHs"
        :items="DRHs"
        :label="user.displayName"
        item-text="nomPrenomGestionnaire"
        v-model="DRH"
        @change="changerDRH"
        item-value="uidGestionnaire"
        single-line
        clearable
      ></v-select>
      <v-progress-circular
        v-else
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-col>
    <v-col cols="12" md="12">
      <v-data-table
        v-if="demandes"
        :headers="headers"
        :items="filteredDemandes"
      >
        <template v-slot:[`header.nomPrenom`]="{ header }">
          {{ header.text }}
          <v-menu offset-y :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon slot="activator" v-bind="attrs" v-on="on">
                <v-icon small :color="filterNomPrenom ? 'info' : ''"
                  >mdi-filter</v-icon
                >
              </v-btn>
            </template>
            <v-card class="block">
              <v-text-field
                v-model="filterNomPrenom"
                label="entrer un élément de recherche"
              >
              </v-text-field>
              <v-btn color="error" small text @click="filterNomPrenom = null"
                >Annuler
              </v-btn>
            </v-card>
          </v-menu>
        </template>
        <template v-slot:[`item.file`]="{ item }">
          <v-btn icon @click="afficherPDF(item)"
            ><v-icon color="green">mdi-book-open-variant</v-icon></v-btn
          >
        </template>
        <template v-slot:[`header.validation`]="{ header }">
          {{ header.text }}
          <v-menu offset-y click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon slot="activator" v-bind="attrs" v-on="on"
                ><v-icon small :color="filterValide ? 'info' : ''"
                  >mdi-filter</v-icon
                ></v-btn
              >
            </template>
            <v-list>
              <v-checkbox
                dense
                label="en cours"
                v-model="filterValide"
                :value="null"
              ></v-checkbox>
              <v-checkbox
                dense
                label="accepté"
                v-model="filterValide"
                :value="true"
              ></v-checkbox>
              <v-checkbox
                dense
                label="refusé"
                v-model="filterValide"
                :value="false"
              ></v-checkbox>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`item.messagerie`]="{ item }">
          <v-col>
            <v-badge
              :color="
                item.nombreMessagesGestionnaire <= 0 ? 'transparent' : 'primary'
              "
              :content="item.nombreMessagesGestionnaire"
            >
              <v-btn
                icon
                @click="lancerMessagerie(item)"
                :color="item.nombreMessagesGestionnaire > 0 ? 'red' : 'grey'"
                ><v-icon>chat</v-icon></v-btn
              >
            </v-badge>
          </v-col>
        </template>
        <template v-slot:[`item.createAt`]="{ item }">
          <v-col>{{
            item.createAt
              ? new Date(item.createAt).toLocaleString("fr-FR", {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })
              : ""
          }}</v-col>
        </template>
        <template v-slot:[`item.validation`]="{ item }">
          <v-col v-if="item.validation == null" color="warning">
            <v-btn
              color="warning"
              @click="openValidation(item)"
              rounded
              outlined
              small
              >A valider &nbsp;<v-icon small
                >mdi-checkbox-marked-circle-outline</v-icon
              ></v-btn
            >
          </v-col>
          <v-chip v-else-if="item.validation == 0" color="error">refusé</v-chip>
          <v-chip v-else-if="item.validation == 1" color="success"
            >accepté</v-chip
          >
        </template>
      </v-data-table>
      <v-dialog v-model="popUpValidation" persistent>
        <BaseBlock>
          <v-row>
            <v-responsive height="500px" width="100px">
              <iframe
                height="100%"
                width="100%"
                :src="iframeSrc"
                title="PDF Changement de RIB"
              ></iframe>
            </v-responsive>
          </v-row>
          <v-row align="center" justify="center"
            ><div clas="text-center" v-if="!traitementEnCours">
              <v-col align-self="end">
                <v-btn color="success" @click="traitementForm(1)"
                  >Accepter</v-btn
                >&nbsp;
                <v-btn color="error" @click="dialogRefus = true">Refuser</v-btn>
                &nbsp;
                <v-btn @click="fermerDialogValidation" color="info"
                  ><v-icon>mdi-close</v-icon>Fermer</v-btn
                >
              </v-col>
            </div>
            <div v-else>
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular></div
          ></v-row>
        </BaseBlock>
      </v-dialog>
      <v-dialog v-model="dialogRefus" persistent>
        <BaseBlock>
          <v-form v-model="validRefus" ref="formRefus" lazy-validation>
            <v-textarea
              v-model="RIB.messageRefus"
              name="Expliquer le refus de la demande"
              label="Expliquez le refus de la demande"
              :rules="[
                (value) => !!value || 'Champ requis.',
                (v) =>
                  (v || '').length <= 4000 ||
                  `le nombre de caractères doit être inférieur à 4000.`,
              ]"
              required
              auto-grow
              counter="4000"
            ></v-textarea>
            <v-row align="center" justify="center"
              ><div clas="text-center">
                <v-col align-self="end">
                  <v-btn
                    color="success"
                    @click="confirmerDialogRefus"
                    :disabled="!validRefus"
                    >Valider</v-btn
                  >
                  <v-btn color="error" @click="annulerRefus">annuler</v-btn>
                </v-col>
              </div></v-row
            >
          </v-form>
        </BaseBlock>
      </v-dialog>
      <v-dialog
        v-model="dialogPDF"
        max-width="500px"
        persistent
        transition="dialog-bottom-transition"
      >
        <BaseBlock>
          <v-row align="center" justify="center">
            <!-- <v-col align="center" justify="center" v-if="affichagePDF"> -->
            <v-responsive height="500px" width="100px">
              <iframe
                height="100%"
                width="100%"
                :src="iframeSrc"
                title="document pdf"
                style="background: #ffffff"
              ></iframe>
            </v-responsive>
          </v-row>

          <v-row justify="center">
            <v-btn
              color="error"
              @click="
                dialogPDF = false;
                iframeSrc = null;
              "
              >fermer</v-btn
            >
          </v-row>
        </BaseBlock>
      </v-dialog>
    </v-col>

    <messagerie ref="messagerie" :temoinGestionnaire="true"></messagerie>
  </v-row>
</template>

<script>
import ApiRibRepository from "@/repositories/ApiRibRepository";
import ApiGestionnaireRepository from "@/repositories/ApiGestionnaireRepository";
import BaseBlock from "@/components/base/BaseBlock";
import { mapState } from "vuex";
import messagerie from "@/components/Messagerie.vue";

export default {
  components: { BaseBlock, messagerie },
  data() {
    return {
      headers: [
        {
          text: "Numéro",
          value: "id",
        },
        {
          text: "Date de création",
          value: "createAt",
        },
        {
          text: "Nom du fichier",
          value: "nameFile",
        },
        { text: "Fichier joint", value: "file" },
        {
          text: "Nom prénom",
          value: "nomPrenom",
        },
        {
          text: "Statut",
          value: "validation",
        },
        {
          text: "Messagerie",
          value: "messagerie",
        },
      ],
      demandes: null,
      RIB: {
        nameFile: null,
        validation: null,
        messageRefus: null,
        noSIRH: null,
      },
      filterValide: [null],
      filterNomPrenom: null,
      editedIndex: null,
      iframeSrc: null,
      popUpValidation: false,
      traitementEnCours: false,
      validRefus: false,
      dialogRefus: false,
      DRHs: null,
      DRH: null,
      dialogPDF: false,
    };
  },
  async created() {
    this.DRHs = await ApiGestionnaireRepository.getGestionnaires();
    this.demandes = await ApiRibRepository.getDemandesGestionnaire();
    console.log(this.demandes);
  },
  computed: {
    ...mapState(["user", "isAdmin"]),
    filteredDemandes() {
      var conditions = [];
      conditions.push(this.filterValidation);
      if (this.filterNomPrenom) {
        conditions.push(this.filtrageNomPrenom);
      }
      if (conditions.length > 0) {
        return this.demandes.filter((demande) => {
          return conditions.every((condition) => {
            return condition(demande);
          });
        });
      }
      return this.demandes;
    },
  },
  methods: {
    async openValidation(item) {
      this.editedIndex = this.demandes.indexOf(item);
      this.RIB = Object.assign({}, item);
      this.iframeSrc = await ApiRibRepository.getDemandeFileDRH(item.id);
      this.popUpValidation = true;
    },

    fermerDialogValidation() {
      this.iframeSrc = "";
      this.popUpValidation = false;
      if (this.$refs.formRefus) this.$refs.formRefus.reset();
    },

    confirmerDialogRefus() {
      if (this.$refs.formRefus.validate()) {
        this.dialogRefus = false;
        this.traitementForm(0);
      }
    },

    annulerRefus() {
      this.RIB.messageRefus = null;
      this.$refs.formRefus.reset();
      this.dialogRefus = false;
    },

    traitementForm(valider) {
      this.$confirm(
        "<b>Confirmez vous votre choix de " +
          (valider == "0" ? "refuser" : "traiter") +
          " la demande ?</b>"
      ).then(async (reponse) => {
        if (reponse) {
          this.finForm = true;
          this.$toast.info("Vous avez confirmé.");

          if (valider == 1) {
            this.RIB.validation = 1;
          } else this.RIB.validation = 0;
          this.$toast.info("envoi du mail en cours...");
          let updateDemande = await ApiRibRepository.updateDemande(this.RIB);
          this.finForm = false;
          Object.assign(this.demandes[this.editedIndex], updateDemande);
          this.editedIndex = -1;
          this.RIB = Object.assign({});
          this.$toast.info("Demande mise à jour.");
          this.popUpValidation = false;
          this.iframeSrc = "";
        } else {
          this.$toast.info("Vous n'avez pas confirmé.");
        }
        if (this.$refs.formRefus) this.$refs.formRefus.reset();
      });
    },
    async changerDRH() {
      if (this.DRH != null) {
        this.loading = true;
        this.demandes = [];
        this.demandes = await ApiRibRepository.getDemandesGestionnaireByUid(
          this.DRH
        );
        this.loading = false;
      } else {
        this.demandes = await ApiRibRepository.getDemandesGestionnaire();
      }
    },
    filtrageNomPrenom(item) {
      return item.nomPrenom
        .toLowerCase()
        .includes(this.filterNomPrenom.toLowerCase());
    },
    filterValidation(item) {
      return this.filterValide.includes(item.validation);
    },
    async afficherPDF(item) {
      this.iframeSrc = await ApiRibRepository.getDemandeFileDRH(item.id);

      this.dialogPDF = true;
    },

    lancerMessagerie(item) {
      this.$refs.messagerie.openMessagerie(item);
      item.nombreMessagesUtilisateur = 0;
    },
  },
};
</script>
